var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22831 3.50881H0.62793V2.25577H9.06647L11.4473 8.01976H34.3988L20.5513 28.1379V34.682L25.6974 37.0212L25.4382 38.2181H14.5367L14.2725 37.0234L19.2982 34.6859V28.1409L5.18731 8.01976H10.0915L8.22831 3.50881ZM19.92 26.8451L25.3741 18.9212H14.363L19.92 26.8451ZM13.4842 17.6682H26.2365L32.0152 9.2728H7.59653L13.4842 17.6682ZM19.9278 35.775L17.3693 36.965H22.5457L19.9278 35.775Z",
    fill: "#0C2487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7921 15.0368C17.2073 15.0368 17.5439 14.7002 17.5439 14.285C17.5439 13.8697 17.2073 13.5331 16.7921 13.5331C16.3769 13.5331 16.0403 13.8697 16.0403 14.285C16.0403 14.7002 16.3769 15.0368 16.7921 15.0368ZM16.7921 16.2898C17.8994 16.2898 18.797 15.3922 18.797 14.285C18.797 13.1777 17.8994 12.2801 16.7921 12.2801C15.6848 12.2801 14.7872 13.1777 14.7872 14.285C14.7872 15.3922 15.6848 16.2898 16.7921 16.2898Z",
    fill: "#0C2487"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0571 13.2825C23.4723 13.2825 23.8089 12.9459 23.8089 12.5307C23.8089 12.1155 23.4723 11.7789 23.0571 11.7789C22.6419 11.7789 22.3053 12.1155 22.3053 12.5307C22.3053 12.9459 22.6419 13.2825 23.0571 13.2825ZM23.0571 14.5355C24.1644 14.5355 25.062 13.6379 25.062 12.5307C25.062 11.4234 24.1644 10.5258 23.0571 10.5258C21.9499 10.5258 21.0522 11.4234 21.0522 12.5307C21.0522 13.6379 21.9499 14.5355 23.0571 14.5355Z",
    fill: "#0C2487"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4577 3.13292C30.5511 3.13292 28.1949 5.48915 28.1949 8.3957H26.9419C26.9419 4.79711 29.8591 1.87988 33.4577 1.87988C37.0563 1.87988 39.9735 4.79711 39.9735 8.3957C39.9735 11.9943 37.0563 14.9115 33.4577 14.9115C31.9793 14.9115 30.6143 14.4184 29.5207 13.588L30.2784 12.59C31.1617 13.2607 32.2624 13.6585 33.4577 13.6585C36.3642 13.6585 38.7205 11.3022 38.7205 8.3957C38.7205 5.48915 36.3642 3.13292 33.4577 3.13292Z",
    fill: "#0C2487"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrink);
export default __webpack_public_path__ + "static/media/iconDrink.fa63dda938a84edb6a03c54c0cdb5e7d.svg";
export { ForwardRef as ReactComponent };